import mod from "-!../../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registration-bonus.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registration-bonus.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/sport-banners/registration-bonus.vue?vue&type=script&lang=js
// module id = vtLd
// module chunks = 0